import * as _ from "lodash";

export const cleanUndefined = <T extends Object>(obj: T) => {
  return _.pickBy(obj, (v) => v !== undefined);
};

export const cleanUndefinedOrEmpty = (obj: any) => {
  return _.pickBy(obj, (v: string) => v !== undefined && v !== "");
};
